import BarCharts from "../ComplaintCharts/VerticalBarChart";
import { axInst } from "../../../Components/Login/Service";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";

const sub_status = async (body) => {
  try {
    const res = await axInst.post("complaints/sub_status_count", body);
    const data = res.data.Total_Sub_Status_Count;
    // console.log(data);

    const keyData = data.map((item) => item.key);
    const valData = data.map((item) => item.SR_NO_COUNT);

    return { keyData, valData };
  } catch (error) {
    console.error(error);
  }
};

export const SubStatus = () => {
  const { data, submitted } = useSelector((e) => e.filtersComplaint);

  const {
    data: regwiseret,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["sub_status", submitted],
    queryFn: () => sub_status(data),
    initialData: { keyData: [], valData: [] },
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  const noDataAvailable =
    !isFetching &&
    !isError &&
    (!regwiseret || !regwiseret.keyData.length || !regwiseret.valData.length);

  return (
    <div className="p-2 relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {/* {!isFetching && !isError && (
        <BarCharts
          line={false}
          color={"#165DFF"}
          xaxisdata={regwiseret?.keyData}
          yaxisdata={regwiseret?.valData}
          heading={"Sub Status"}
        />
      )} */}
      {noDataAvailable ? (
        <div className="grid items-center justify-center w-full h-full">
          <p>Data Not Available</p>
        </div>
      ) : (
        !isFetching &&
        !isError && (
          <BarCharts
            line={false}
            color={"#165DFF"}
            xaxisdata={regwiseret?.keyData}
            yaxisdata={regwiseret?.valData}
            heading={"Sub Status"}
            headingColor={"#4f4f4f"}
            headingFont={"16"}
          />
        )
      )}
    </div>
  );
};
